import React, { useState } from "react";

export const Details = ({ data }) => {
  const [daysActive, setDaysActive] = useState(false);

  const handleDays = () => {
    setDaysActive(!daysActive)

  };
  return (
    <div className="serviceDetails">
      {/* <div className="serviceCard">
        <div className="cardTitles">
          <span>گواهینامه های کسب شده</span>
          <i className="icon-chevron-left"/>
        </div>
        <div className="subProperties">
          <div></div>
        </div>
      </div> */}
      <div className="cardTitles">
        <span>سرویس ها انجام شده</span>
        <span className="subStats"> {data.services_count} سرویس</span>
      </div>
      <div className="serviceCard">
        <div className="cardTitles" onClick={handleDays}>
          <span>ساعت ها و روز های کاری</span>
          <i
            className={`icon-chevron-left ${
              daysActive ? "iconRotate360" : "iconRotate180"
            }`}
          />
        </div>
        {daysActive ? (
          <div className="subProp">
            {data.days.length !== 0 ? (
              data.days.map((day) => (
                <div className="subPropCard">
                  <span>{day.name}</span>
                  <span>{day.active_hours}</span>
                </div>
              ))
            ) : (
              <div className="subPropCard">روز های کاری مشخص نشده اند</div>
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="serviceFooter">
        <div className="footerHead">
          <span className="footerTitle">توضیحات تعمیرگاه {data.name}</span>
          <span>{data.details}</span>
        </div>
      </div>
    </div>
  );
};
